import { Component, input, OnInit, Signal } from '@angular/core';
import { CBaseComponent } from '../base/c-base.component';
import { ElementsType } from '../../../state-management/model/enums/state.enums';
import { Result } from '../../../state-management/model/interfaces/state.model';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { EditableTextComponent } from "../../base/text/editable-text/editable-text.component";

@Component({
  selector: 'app-c-quote',
  imports: [EditableTextComponent],
  templateUrl: './c-quote.component.html',
  styleUrl: './c-quote.component.scss'
})
export class CQuoteComponent implements OnInit {
  readonly componentId = input<string>('');

  public quoteTextId!: Signal<Result<string, string>>;
  public authorId!: Signal<Result<string, string>>;

  constructor(private stateService: WebsiteStateService) { }

  ngOnInit(): void {
    this.quoteTextId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'quote-text');
    this.authorId = this.stateService.getSingleElementIdByLabelAndComponent(this.componentId(), 'author');
  }
}
